/**
 * チェックボックスの判定に応じて、確認画面へ遷移するボタンを有効/無効化する。
 * フレームワークの機能に沿っていないので注意。
 * name属性を記入すると確認画面に表示されるため、input=checkboxには、name属性は書いていない。
 */
$(function () {
  function updateButtonState() {
    if ($('#term').prop('checked')) {
      // チェックされている場合、ボタンを有効化
      $('.js-term-button').prop('disabled', false).css({
        'background-color': '',
        'pointer-events': 'auto',
      });
    } else {
      // チェックされていない場合、ボタンを無効化
      $('.js-term-button').prop('disabled', true).css({
        'background-color': '#999',
        'pointer-events': 'none',
      });
    }
  }

  // チェックボックスの状態を監視
  $('#term').on('change', updateButtonState);

  // 画面ロード時にチェックを外し、初期状態を設定
  $('#term').prop('checked', false).trigger('change');

  // 少し遅延させてから再度チェックを外す
  setTimeout(function () {
    $('#term').prop('checked', false).trigger('change');
    updateButtonState();
  }, 100);
});
